import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import * as React from 'react';
import CustomTextField from '../CustomFields/CustomTextField';
import Button from '@mui/material/Button';
import './Inicio.css';
import { validationFormTerm } from './ValidationForm';
import CustomErrorMessage from '../CustomFields/CustomErrorMessage';
import { handleMaxLength } from '../Utils/FieldValidationFunctions';
import { INTER_CONTRATANE } from '../Utils/Constantes';



export default function FormDialogContacto(props) {

  let contacto = JSON.parse(sessionStorage.getItem("tipoContacto"));

  const handleChangeTerminos = (event, setFieldValue) => {
    setFieldValue('terminos', event.target.checked);
  };

  const handleGuardar = (values, setSubmitting) => {
    let interGMM = {};
    if (sessionStorage.getItem(INTER_CONTRATANE)) {
      interGMM = JSON.parse(sessionStorage.getItem(INTER_CONTRATANE));
    }
    interGMM.telefono = values.telefono;
    interGMM.correo = values.correo;
    interGMM.terminos = true;
    window.sessionStorage.setItem(INTER_CONTRATANE, JSON.stringify(interGMM));
    setSubmitting(false);
    props.handleClose();
  };


  return (
    <Formik
      validateOnChange={true}
      initialValues={{
        telefono: '',
        correo: '',
        terminos: 'false',
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        handleGuardar(values, setSubmitting);
      }}
      validationSchema={validationFormTerm}>
      {({ values, submitForm, setFieldValue, handleChange, errors, isSubmitting, setFieldError, touched, setFieldTouched, }) => (
        <Form>
          <Grid container direction="column" justifyContent="center" alignItems="center">
            <div>
              {(() => {
                if (contacto !== 2) {
                  return (
                    <Grid container direction="column" justifyContent="center" alignItems="center">
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                        <div className="w-100">
                          <div className="textDudas">Por favor, indicanos el n&uacute;mero de celular en el que deseas recibir nuestro seguimiento y comunicaci&oacute;n</div>
                        </div>
                      </Grid>
                      <div className=" espacio w-100">
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                          <CustomTextField id="telefono" name="telefono" type="text" placeholder="Tel&eacute;fono"
                            onChange={(event) => handleMaxLength(event, setFieldValue, "telefono", 10)}
                          />
                        </Grid>
                      </div>
                      <div className=" espacio w-100">
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <div className="textDudas">En caso de no poder contactarte, ¿A qu&eacute; correo podr&iacute;amos escribirte?</div>
                        </Grid>
                      </div>
                      <div className=" espacio w-100">
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <CustomTextField id="correo" name="correo" type="text" placeholder="Correo electr&oacute;nico" />
                        </Grid>
                      </div>
                    </Grid>
                  )
                } else {
                  return (
                    <div>
                      <Grid container direction="column" justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                          <div className="w-100">
                            <div className="textDudas">Por favor, indicanos el correo electr&oacute;nico en el que deseas recibir nuestro seguimiento y comunicaci&oacute;n</div>
                          </div>
                        </Grid>
                        <div className=" espacio w-100">
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <CustomTextField id="correo" name="correo" type="text" placeholder="Correo electr&oacute;nico" />
                          </Grid>
                        </div>
                        <div className=" espacio w-100">
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className="textDudas">En caso de no poder contactarte, ¿A qu&eacute; tel&eacute;fono podr&iacute;amos llamarte o mandar mensajes?</div>
                          </Grid>
                        </div>
                        <div className=" espacio w-100">
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <CustomTextField id="telefono" name="telefono" type="text" placeholder="Tel&eacute;fono"
                              onChange={(event) => handleMaxLength(event, setFieldValue, "telefono", 10)}
                            />
                          </Grid>
                        </div>
                      </Grid>
                    </div>
                  )
                }
              })()}
            </div>
            <div className="espacio w-100" >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormControlLabel
                  name='terminos'
                  control={<Checkbox />}
                  label=''
                  onChange={(event) =>
                    handleChangeTerminos(event, setFieldValue)}
                />
                Aceptar<a className="href-modal" target="_blank" href="https://inter.mx/aviso-de-privacidad" rel="noreferrer" >Aviso de privacidad</a>
                <CustomErrorMessage
                  name='terminos'
                />
              </Grid>
            </div>
            <div className="espacio w-100" >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button className="w-100" variant="contained"
                  onClick={submitForm} disabled={isSubmitting}
                >
                  Guardar
                </Button>
              </Grid>
            </div>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}